import { Component, OnInit } from '@angular/core';
import { ROUTES, RouteInfo } from './rol-sidebar.metadata';

@Component({
  selector: 'app-rol-sidebar',
  templateUrl: './rol-sidebar.component.html',
  styleUrls: ['./rol-sidebar.component.css']
})
export class RolSidebarComponent {
  public sidebarnavItems: RouteInfo[] = [];

  ngOnInit() {
    const userRoles = JSON.parse(localStorage.getItem('roles') || '["USER"]');
    this.sidebarnavItems = this.filterByRoles(ROUTES, userRoles);
  }

  private filterByRoles(routes: RouteInfo[], userRoles: string[]): RouteInfo[] {
    return routes
      .map(route => {
        const filteredSubmenu = this.filterByRoles(route.submenu, userRoles);
        const hasRole = !route.roles || route.roles.some(role => userRoles.includes(role));
        if (hasRole || filteredSubmenu.length > 0) {
          return { ...route, submenu: filteredSubmenu };
        }
        return null;
      })
      .filter((r): r is RouteInfo => r !== null);
  }
}
